import { SetMetadata } from '@nestjs/common';

/**
 * Public 装饰器的元数据键
 */
export const IS_PUBLIC_KEY = 'isPublic';

/**
 * 标记接口为公开接口，跳过 AuthNPaasGuard 的鉴权检查
 * 
 * @example
 * ```typescript
 * @Controller('mock-api/users')
 * @Public()  // 控制器级别
 * export class MockPermissionController {
 *   @Get(':userId/permissions')
 *   getUserPermissions() {}
 * }
 * 
 * // 或者在方法级别
 * @Controller('api')
 * export class ApiController {
 *   @Get('public-info')
 *   @Public()  // 方法级别
 *   getPublicInfo() {}
 * }
 * ```
 */
export const Public = () => SetMetadata(IS_PUBLIC_KEY, true);

